<dialog class="gallery" #dialogElement>

  <button role="button" class="gallery__close-button" (click)="onClosed.emit(true)"><brt-icon [icon]="'x-thin'"></brt-icon></button>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-6">
        <div class="gallery__title">{{data.title}}</div>

        <div class="gallery__filter" *ngIf="!filterHidden">
          <button role="button" class="gallery__filter-item" [ngClass]="{'active': mode.key === currentFilter}" *ngFor="let mode of filterMods" (click)="setFilter(mode.key)">{{mode.label}}</button>
        </div>

        <div class="gallery__content">
          <div class="gallery__column" *ngFor="let column of filteredColumns; index as columnIdx">
            <ng-container *ngFor="let item of column; index as itemIdx">
              <div class="gallery__item" *ngIf="item.type === currentFilter || currentFilter === 'all'" (click)="openSlider(item, (columnIdx + 1) + itemIdx * filteredColumns.length - 1)">
                <brt-gallery-item [item]="item"></brt-gallery-item>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</dialog>
